import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-link-home", end: true },
  { to: "/lab", label: "The Lab", testid: "nav-link-lab" },
  { to: "/playbook", label: "Our Playbook", testid: "nav-link-playbook" },
  { to: "/experience", label: "The Experience", testid: "nav-link-experience" },
  { to: "/programme", label: "Programme", testid: "nav-link-programme" },
  { to: "/team", label: "Organising Team", testid: "nav-link-team" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="wrap nav">
        <Link className="brand" to="/" data-testid="nav-brand-logo" onClick={() => setOpen(false)}>
          <span className="mark">KOS-LAB</span>
          <span>
            KOSS 2027
            <small>KUNLE OPARINDE STRATEGY SUMMIT</small>
          </span>
        </Link>
        <nav className="links">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} className={({ isActive }) => (isActive ? "active" : "")} data-testid={l.testid}>
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="nav-actions">
          <Link className="btn" to="/apply" data-testid="nav-apply-button">Apply for a Seat ↗</Link>
          <button
            className="menu-btn"
            onClick={() => setOpen(!open)}
            aria-label={open ? "Close menu" : "Open menu"}
            data-testid="nav-menu-btn"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            className="mobile-links"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            data-testid="mobile-menu"
          >
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testid}`}
              >
                {l.label}
              </NavLink>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
}
